import { clientAxios8080 } from '../../../../configs/axios';

let idCounter = 1;

const getIncumplimiento = async (limit, offSet) => {
  try {
    const url = `/ms-tickets/serviceLevels/getTicketReporteEntrega?limit=${limit}&offSet=${offSet}`;
    const response = await clientAxios8080.get(url);
    const responseData = response.data.data;

    // Agregar un id único a cada objeto de fila
    // eslint-disable-next-line no-plusplus
    const rowsWithIds = responseData.map((row) => ({ id: idCounter++, ...row }));

    // Hacer algo con los datos, por ejemplo:
    // actualizar el estado o realizar alguna lógica específica
    console.log(rowsWithIds);

    return rowsWithIds;
  } catch (error) {
    console.error('Error fetching data:', error);
    // Manejar el error según sea necesario
    return []; // Devolver un array vacío en caso de error
  }
};

export default getIncumplimiento;
